import React from 'react';

const UsageTable = ({
  settings = []
}) => {
  return (
    <div className='Section'>
      <div className='MainHeader MainHeader--flexible'>
        <h3 className='MainHeader__h3'>Status</h3>
      </div>

      <div className='Table Table--settings-usage-list'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th Table__col--center Table__col--ta-c'>
            <span className='Badge Badge--block'>ON</span>
          </div>
        </div>
        {settings.map((setting) =>
          <div className='Table__row' key={setting.title}>
            <div className='Table__col Table__col--ta-c'>
              <span className='Dot' /> {Math.trunc(setting.onPercentage*100) + '%'}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default UsageTable;
